<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0">渠道列表</h3>
      <div class="pull-right">
        <el-input placeholder="搜索渠道" class="max-width-200 w-a"
                  suffix-icon="el-icon-search" v-model="search"></el-input>
        <el-button type="primary" @click="create()" :loading="create_loading>0">创建渠道</el-button>
      </div>
    </div>
    <el-table :data="page" border>
      <template slot="empty">
        <div v-if="ready">
          <div v-if="!list.length">暂无数据</div>
          <div v-else-if="!filtered.length">无匹配结果</div>
        </div>
      </template>
      <el-table-column label="渠道" prop="name" label-class-name="no-selectable c-p"
                       sortable sort-by="$$pinyin.name.full">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.name, scope.row.$$pinyin.name)"></span>
        </template>
      </el-table-column>
      <el-table-column label="用户名" prop="username" sortable label-class-name="no-selectable c-p">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.username, scope.row.$$pinyin.username)"></span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="time_create" sortable
                       label-class-name="no-selectable c-p">
        <template slot-scope="scope">{{scope.row.time_create | sub(0, -3)}}</template>
      </el-table-column>
      <el-table-column label="初始密码" align="center">
        <template slot-scope="scope">
          <div v-loading.body="scope.row.$$get_password_loading>0">
            <div v-if="!!scope.row.$$password">{{scope.row.$$password}}</div>
            <div v-else @click="getOriginPassword(scope.row)" class="c-p">******</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="查看" align="center" v-if="$location.admin_school.auth()">
        <template slot-scope="scope">
          <router-link :to="$location.admin_school({channel_uid: scope.row.uid})"
                       class="el-button el-button--mini el-button--primary">
            学校
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="edit(scope.row, scope.$index)"
                     :disabled="scope.row.$$editLoading>0">
            修改
          </el-button>
          <el-button size="mini" type="warning" @click="resetPassword(scope.row,scope.$index)"
                     :disabled="scope.row.$$reset_password_loading>0">
            重置密码
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import * as Channel from 'api/channel'
import page from 'utils/page'

import passwordMixin from '../passwordMixin'

export default {
  mixins: [passwordMixin],
  data () {
    return {
      ready: false,
      list: [],
      pageInfo: {page: 10, current: 1},
      search: '',
      create_loading: 0,
    }
  },
  computed: {
    filtered () {
      return this.$search(this.list, this.search, ['name', 'username'])
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        this.list = await Channel.list()
        this.ready = true
      })
    },
    async create () {
      if (this.create_loading > 0) return
      let name = await this.$prompt('请输入渠道名称', '创建渠道')
      if (!name) return
      this.$guard(this, 'create_loading')(async () => {
        let channel = await Channel.edit({name})
        this.$message.success('创建成功')
        this.resetItem(channel)
        this.list.unshift(channel)
      })
    },
    async edit (channel) {
      if (channel.$$editLoading > 0) return
      let name = await this.$prompt('请输入渠道名称', '编辑渠道', {
        inputValue: channel.name,
        confirmButtonText: '更新',
      })
      if (!name) return
      this.$guard(channel, '$$editLoading')(async () => {
        await Channel.edit({channel_uid: channel.uid, name})
        this.$message.success('更新成功')
        channel.name = name
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/account/channel/ChannelList.vue